import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState("judge"); // "judge" | "superadmin"

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("kwc_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setMode(data.is_superadmin ? "superadmin" : "judge");
    } catch (e) {
      localStorage.removeItem("kwc_token");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (name, password) => {
    const { data } = await api.post("/auth/login", { name, password });
    localStorage.setItem("kwc_token", data.token);
    setUser(data.user);
    setMode(data.user.is_superadmin ? "superadmin" : "judge");
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("kwc_token");
    setUser(null);
  };

  const switchMode = () => {
    if (!(user?.is_superadmin && user?.is_judge)) return;
    setMode((m) => (m === "superadmin" ? "judge" : "superadmin"));
  };

  return (
    <AuthContext.Provider value={{ user, loading, mode, login, logout, switchMode }}>
      {children}
    </AuthContext.Provider>
  );
}
